import React from "react";
import "../../style/ProfilPlayerSmall.css"
import { NavLink } from "react-router";

const ProfilPlayerSmall = ({
  profilPlayer,
  place = null,
}) => {



    return (
      <NavLink title="Voir le profil" className={`profilPlayerSmall_div ${place && place===1? `gold` : place===2? `silver` : place===3? `bronze` : ``}`} to={`/profil/${profilPlayer.id}`}>
          {place ? <h2 className="profilPlayerSmall_place">{place}</h2> : null}
          {profilPlayer.profilPicture ? <img className="profilPlayerSmall_img" src={profilPlayer.profilPicture} alt="Photo de profil" /> : null}
          <p className="profilPlayerSmall_pseudo">{profilPlayer.pseudo}</p>
      </NavLink>
    )
  
};
ProfilPlayerSmall.propTypes = {
};

export default ProfilPlayerSmall;
